import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ToggleWithLabel } from "../../general/toggle/toggleWithLabelProps.component";
import { SettingsSection } from "../companySettingsMobileView/companySystemSettings/settingSection.component";

export const LocalStampClockSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const [touched, setTouched] = useState(false);
  const showError = touched && value === undefined;

  const handleToggle = (next: boolean) => {
    setTouched(true);
    onChange(next);
  };

  return (
    <SettingsSection
      title={t("ProfileCompany.LocalStampClock")}
      info={t("ProfileCompany.LocalStampClockHelpText")}
    >
      <ToggleWithLabel
        label={t("ProfileCompany.LocalStampClock")}
        leftLabel={t("System.Off")}
        rightLabel={t("System.On")}
        value={value}
        onChange={handleToggle}
        required
        hasError={showError}
        errorText={showError ? t("System.Required") : undefined}
      />
    </SettingsSection>
  );
};
